module.exports = __webpack_public_path__ + "bb7b7b420ae0f39ac54bc787d878dc91.svg";